module.exports = __webpack_public_path__ + "img/KW.e38a0f84.svg";